module.exports = __webpack_public_path__ + "img/logo.27996388.svg";